import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';

import { Code } from '@mtna/pojo-consumer-ui';

/**
 * Codes Table Component to display codes in a table with pagination.
 *
 * @author Zach Edwards <zach.edwards@mtna.us>
 */
@Component({
  selector: 'rds-codes-table',
  templateUrl: './codes-table.component.html',
  styleUrls: ['./codes-table.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RdsCodesTableComponent {
  /** Required codes to display */
  @Input() codes: Array<Code>;
  /** The length of the total number of codes that are being paginated */
  @Input() length: number;
  /** Number of codes to display on a page */
  @Input() pageSize: number;
  /** The zero-based page index of the displayed list of codes */
  @Input() pageIndex: number;
  /** Event emitted when the paginator changes the page size or page index */
  @Output() pageChange = new EventEmitter<PageEvent>();

  displayedColumns = ['codeValue', 'name'];
}
